export default __webpack_public_path__ + "static/media/vetorSignature.8014a42f.svg";